<template>
  <section id="destinations" class="destination-map page-row page-row-sunburst">
    <div class="container-fluid">
      <div class="col-sm-12">
        <header class="header-section">
          <span class="fa">
            <font-awesome-icon :icon="['far', 'map']" />
          </span>
          <h2 class="section-heading">Select a Destination:</h2>
        </header>
        <ul class="park-map-list">
          <li v-for="site in parkMapInfo" v-bind:key="site.id">
            <a
              v-if="site.state === true"
              :href="stateUrl + '/Park/' + site.id"
              :style="'left:' + site.mapx + 'px; top:' + site.mapy + 'px;'"
            >
              <div class="park-info">
                {{ site.name }}
                <span class="park-admin">{{ site.agencyName }}</span>
              </div>
            </a>
            <a
              v-else-if="site.agency === true"
              :href="stateUrl + '/Parks/' + site.id"
              :style="'left:' + site.mapx + 'px; top:' + site.mapy + 'px;'"
            >
              <div class="park-info">
                {{ site.name }}
                <span class="park-admin">{{ site.agencyName }}</span>
              </div>
            </a>
            <router-link
              v-else
              :to="{ name: 'siteInput', params: { siteId: site.id } }"
              :style="'left:' + site.mapx + 'px; top:' + site.mapy + 'px;'"
            >
              <div class="park-info">
                {{ site.name }}
                <span class="park-admin">{{ site.agencyName }}</span>
              </div>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import ParkData from "@/data/parkData.js";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faMap } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faMap);

export default {
  components: {
    FontAwesomeIcon
  },
  computed: {
    parkMapInfo() {
      let parkData = new ParkData();
      return parkData.get().sort((a, b) => (a.name > b.name ? 1 : -1));
    },
    stateUrl() {
      return process.env.VUE_APP_STATE_URL;
    }
  }
};
</script>
